export default {
  header: {
    title: 'Smart Energy Storage Lighting Visualization Platform',
    adminControl: 'Admin Control',
    threePhase: 'Three-Phase'
  },
  weather: {
    sunny: 'Sunny',
    rainy: 'Rainy',
    snowy: 'Snowy',
    cloudy: 'Cloudy'
  },
  common: {
    loading: 'Loading...',
    voltage: 'Voltage',
    current: 'Current',
    power: 'Power',
    consumption: 'Consumption',
    frequency: 'Freq',
    grid: 'Grid',
    storage: 'Storage',
    pv: 'PV',
    back: 'Back',
    on: 'On',
    off: 'Off'
  },
  overview: {
    title: 'Device Overview',
    online: 'Online',
    offline: 'Offline'
  },
  benefits: {
    title: 'Environmental Benefits',
    reduction: 'Reduction',
    planting: 'Planting',
    trees: 'trees'
  },
  cumulative: {
    title: 'Annual Cumulative Benefits',
    gridConsumption: 'Grid Consum.',
    storageConsumption: 'Storage Consum.',
    pvGeneration: 'PV Generation'
  },
  storage: {
    title: 'Storage Parameters',
    batteryVoltage: 'Battery Volt.',
    batteryCurrent: 'Battery Curr.',
    soc: 'SOC'
  },
  pv: {
    title: 'PV Parameters',
    irradiation: 'Irradiance',
    voltage: 'PV Voltage',
    current: 'PV Current',
    power: 'Charging Power'
  },
  grid: {
    title: 'Grid Parameters',
    voltage: 'Grid Voltage',
    current: 'Grid Current',
    totalPower: 'Total Power'
  },
  center: {
    title: 'Electricity Statistics',
    peakStorage: 'Peak Storage Discharge',
    lowValley: 'Low Valley Light/Storage',
    pvGeneration: 'PV Generation'
  },
  bms: {
    title: 'BMS Battery Monitoring Interface',
    deviceId: 'Device ID',
    prevPage: 'Previous',
    nextPage: 'Next',
    temperature: 'Temp.',
    endurance: 'Endurance',
    pvVoltage: 'PV Volt.',
    totalVoltage: 'Total Volt.',
    remainingEnergy: 'Battery',
    power: 'Power',
    equilibriumState: 'Equilibrium',
    pvDailyGeneration: 'PV Daily Gen.',
    maxVoltage: 'Max Cell Volt.',
    minVoltage: 'Min Cell Volt.',
    chargingCapacity: 'Charging Cap.',
    dischargeCapacity: 'Discharge Cap.',
    hours: 'h',
    minutes: 'm',
    workingCurrent: 'Working Curr.',
    noData: 'No Data'
  },
  map: {
    title: 'Energy Storage Street Light Distribution Map',
    costSavings: 'Cost Savings',
    batteryCapacity: 'Battery Capacity',
    differentialPressure: 'Diff. Pressure',
    peakTime: 'Peak Time',
    lowValleyTime: 'Low Valley Time',
    lowValleyPrice: 'Low Valley Price',
    peakPrice: 'Peak Price',
    confirm: 'Confirm',
    cancel: 'Cancel',
    streetLight: 'Street Light',
    lowValleyLightingYear: 'Low Valley Lighting (year)',
    peakStorageDischargeYear: 'Energy Storage Discharge (year)',
    photovoltaicYear: 'Photovoltaic (year)',
    carbonReduction: 'Carbon Dioxide Reduction',
    equivalentPlanting: 'Equivalent Tree Planting'
  },
  electricity: {
    title: 'Municipal Electricity Statistics',
    pvTitle: 'Photovoltaic Energy Statistics',
    municipalElectricity: 'Municipal Electricity Statistics',
    photovoltaicEnergy: 'Photovoltaic Energy Statistics',
    power: 'Power',
    powerUnit: '(W)',
    gridVoltage: 'Grid Voltage',
    gridVoltageUnit: '(V)',
    gridCurrent: 'Grid Current',
    gridCurrentUnit: '(mA)',
    powerFactor: 'Power Factor',
    powerFactorUnit: '(PF)',
    gridConsumption: 'Grid Consumption',
    gridConsumptionUnit: '(Wh)',
    irradiation: 'Irradiation',
    pvVoltage: 'PV Voltage',
    pvCurrent: 'PV Current',
    chargePower: 'Charge Power',
    prevPage: 'Previous',
    nextPage: 'Next',
    noData: 'No Data'
  },
  threePhase: {
    title: 'Smart Cloud Eye Visualization System',
    onlineRate: 'Device Online Rate',
    voltageA: 'Line A Voltage',
    voltageB: 'Line B Voltage',
    voltageC: 'Line C Voltage',
    phaseVoltage: 'Phase Voltage',
    projectName: 'Project Name',
    threePhase: 'Three Phase',
    combinedPhase: 'Combined Phase',
    positioning: 'Positioning',
    compare: 'Year-on-year',
    phaseA: 'Phase A',
    phaseB: 'Phase B',
    phaseC: 'Phase C',
    harmonicDistortion: 'Harmonic Distortion',
    current: 'Current',
    power: 'Power',
    powerFactor: 'Power Factor',
    powerStats: 'Power Consumption Stats',
    energyConsumption: 'Energy Consumption',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    consumption: 'Consumption',
    tbd: 'TBD',
    button: 'Button'
  }
}
